<template>
  <div class="mb-puzzle">
    <transition name="modal-fade">
      <preview-modal v-if="preview" @modal-off="preview = false" :img-src="startGameConfig.puzzle.src"></preview-modal>
    </transition>
    <svg width="0" height="0">
      <defs>
        <clipPath
          :id="'clip' + indexClip"
          clipPathUnits="objectBoundingBox"
          :key="'puzzle-clip-path-' + indexClip"
          v-for="(puzzleClip, indexClip) in puzzle"
        >
          <path :d="puzzleClip.clipPath[0]" />
          <path :d="puzzleClip.clipPath[1]" />
          <path :d="puzzleClip.clipPath[2]" />
          <path :d="puzzleClip.clipPath[3]" />
        </clipPath>
      </defs>
    </svg>
    <div v-if="show && puzzle.length > 0" style="width: 100%; height: 100%">
      <div
        class="puzzle-grid"
        v-if="puzzle.length > 0"
        :style="{
          display: 'flex',
          'flex-flow': 'row wrap',
          'align-items': 'center',
          'justify-content': 'center',
        }"
      >
        <div
          :style="{
            'max-width':
              startGameConfig.puzzle.numerOfX * (puzzle[0].cropp.width - puzzle[0].cropp.widthPlus) + 2 + 'px',
            margin: 'auto',
            'max-height':
              startGameConfig.puzzle.numerOfY * (puzzle[0].cropp.height - puzzle[0].cropp.heightPlus) + 'px',
            display: 'flex',
            'flex-flow': 'row wrap',
            border: '1px solid black',
          }"
        >
          <div
            :ref="'puzzle-grid-' + indexGrid"
            class="puzzle-grid-piece"
            :key="'puzzle-grid-' + indexGrid"
            v-for="(puzzleGrid, indexGrid) in puzzle"
            :style="{
              width: puzzleGrid.cropp.width - puzzleGrid.cropp.widthPlus - 0 + 'px',
              height: puzzleGrid.cropp.height - puzzleGrid.cropp.heightPlus - 0 + 'px',
              padding: 0,
              border: '1px solid black',
            }"
          ></div>
          <div class="preview" @click="preview = true"><div>Podgląd</div></div>
        </div>
      </div>
      <vue-drag-resize
        class="puzzle-piece"
        :key="'crop-' + index"
        v-for="(crop, index) in puzzle"
        :is-resizable="false"
        :is-active="false"
        :parent-limitation="true"
        :snap-to-grid="true"
        :w="crop.cropp.width"
        :h="crop.cropp.height"
        :x="crop.pos.x"
        :y="crop.pos.y"
        @clicked="info(crop.clipPathArray), info(crop.clipPath)"
        @dragstop="resize($event, index)"
        :style="{
          'sclip-path': 'polygon(' + crop.clipPath + ')',
          'clip-path': 'url(#clip' + index + ')',
        }"
      >
        <cropp-image :img-config="crop"> </cropp-image>
        <!-- <h1 style="position: absolute; color: green; top: 0; left: 80">{{ crop.correct }}</h1> -->
      </vue-drag-resize>
    </div>
    <mb-audio-in-game
      :key="data.top + data.left + 'audio' + index"
      v-for="(data, index) in startGameConfig.mbAudioItemData"
      :item-data="data"
    ></mb-audio-in-game>
  </div>
</template>
<script>
import { Howler } from 'howler';
import PreviewModal from './Preview/PreviewModal';
import defaultMixin from '../../mixins/defaultMixin';
import mbAudioInGame from '../../../MbAudioModal/MbAudioInGame';
import CroppImage from '../../../CroppImage/CroppImage';
export default {
  name: 'mb-puzzle',
  components: { mbAudioInGame, CroppImage, PreviewModal },
  mixins: [defaultMixin],
  props: {
    startGameConfig: {
      type: Object,
      default: function() {
        return {};
      },
    },
    assets: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {
      currentImg: -1,
      audio: null,
      puzzle: [],
      correct: [],
      show: false,
      preview: false,
      path: 'M .245,.755, .5,.5 .755,.755 .6,.755 C.65, 1 .35,1 .4,.755z',
    };
  },
  mounted() {
    this.init();
    this.show = true;
  },
  methods: {
    checkGameAction() {
      return this.puzzle.every((x) => x.correct == x.connected);
    },
    resetGameAction() {
      this.puzzle = [];
      this.correct = [];
      this.show = false;
      this.preview = false;
      this.init();
      this.show = true;
    },
    clipPathCreate(symbol, side) {
      // <!-- BOT -->
      // <path d="M .245,.755, .5,.5 .755,.755 .6,.755 C.65, 1 .35,1 .4,.755z" />
      // <!-- TOP -->
      // <path d="M .755,.245 .5,.5 .245,.245 .4,.245 C.35, 0 .65,0 .6,.245z" />
      // <!-- LEFT -->
      // <path d="M .245,.755 .5,.5 .245,.245 .245,.4 C0, .35 0,.65 .245,.6z" />
      // <!-- RIGHT -->
      // <path d="M .755,.755 .5,.5 .755,.245 .755,.4 C1, .35 1,.65 .755,.6z" />
      if (side == 0) {
        //Left
        if (symbol == 0) {
          return 'M .245,.755 .5,.5 .245,.245z ';
        } else if (symbol == 1) {
          // return 'M .245,.755 .5,.5 .245,.245 C.2,.25 .2,.75 .245,.755z ';
          return 'M .245,.755 .5,.5 .245,.245 .245,.45 C0,.25 0,.75 .245,.55z ';
          // return 'M .245,.755 .5,.5 .245,.245 C.23,.3375 .23,.3375 .245,.45 C0,.25 0,.75 .245,.55 C .23,.665 .23,.665 .245,.775z ';
        } else if (symbol == 9) {
          // return 'M .245,.755 .5,.5 .245,.245z ';
          // return 'M .245,.755 .5,.5 .245,.245  C.3,.25 .3,.75 .245,.755z ';
          return 'M .245,.755 .5,.5 .245,.245 .245,.46 C.50,.25 .50,.75 .245,.54z ';
        }
      } else if (side == 1) {
        //Top
        if (symbol == 0) {
          return 'M .755,.245 .5,.5 .245,.245z ';
        } else if (symbol == 1) {
          // return 'M .755,.245 .5,.5 .245,.245z ';
          // return 'M .755,.245 .5,.5 .245,.245 C.25, .2 .75,.2 .755,.245z ';
          return 'M .755,.245 .5,.5 .245,.245 .45,.245 C.25, 0 .75,0 .55,.245z ';
        } else if (symbol == 9) {
          // return 'M .755,.245 .5,.5 .245,.245z ';
          // return 'M .755,.245 .5,.5 .245,.245 C.25,.30 .75,.30 .755,.245z ';
          return 'M .755,.245 .5,.5 .245,.245 .46,.245 C.25,.50 .75,.50 .54,.245z ';
        }
      } else if (side == 2) {
        //Right
        if (symbol == 0) {
          return 'M .755,.755 .5,.5 .755,.245 .755,.6z ';
        } else if (symbol == 1) {
          // return 'M .755,.755 .5,.5 .755,.245 .755,.6z ';
          // return 'M .755,.755 .5,.5 .755,.245 C.8,.25 .8,.75 .755,.755z ';
          return 'M .755,.755 .5,.5 .755,.245 .755,.45 C1,.25 1,.75 .755,.55z ';
        } else if (symbol == 9) {
          // return 'M .755,.755 .5,.5 .755,.245 .755,.6z ';
          // return 'M .755,.755 .5,.5 .755,.245 C.7,.25 .7,.75 .755,.755z ';
          return 'M .755,.755 .5,.5 .755,.245 .755,.46 C.5,.25 .5,.75 .755,.54z ';
        }
      } else if (side == 3) {
        //Bot
        if (symbol == 0) {
          return 'M .245,.755, .5,.5 .755,.755z';
        } else if (symbol == 1) {
          // return 'M .245,.755, .5,.5 .755,.755z';
          // return 'M .245,.755, .5,.5 .755,.755 C.75, .8 .25,.8 .245,.755z';
          return 'M .245,.755, .5,.5 .755,.755 .55,.755 C.75, 1 .25,1 .45,.755z';
        } else if (symbol == 9) {
          // return 'M .245,.755, .5,.5 .755,.755z';
          // return 'M .245,.755, .5,.5 .755,.755 C.75, .7 .25,.7 .245,.755z';
          return 'M .245,.755, .5,.5 .755,.755 .54,.755 C.75, .50 .25,.50 .46,.755z';
        }
      }
    },
    info(data) {
      console.log(data);
    },
    checkPosition(x, y, index) {
      // console.log(this.$refs['puzzle-grid-0']);
      let puzzleField = document.getElementsByClassName('puzzle-grid-piece');
      //console.log(puzzleField);
      for (let i = 0; i < puzzleField.length; i++) {
        if (
          x >= parseInt(puzzleField[i].offsetLeft) &&
          x <= parseInt(puzzleField[i].offsetLeft) + parseInt(puzzleField[i].clientWidth) &&
          y >= parseInt(puzzleField[i].offsetTop) &&
          y <= parseInt(puzzleField[i].offsetTop) + parseInt(puzzleField[i].offsetTop)
        ) {
          //console.log(i);
          this.puzzle[index].pos.x = puzzleField[i].offsetLeft - this.puzzle[index].cropp.widthPlus / 2;
          this.puzzle[index].pos.y = puzzleField[i].offsetTop - this.puzzle[index].cropp.heightPlus / 2;
          this.puzzle[index].connected = i;
        }
      }
    },
    resize(e, index) {
      this.puzzle[index].pos.x = e.left;
      this.puzzle[index].pos.y = e.top;
      this.puzzle[index].connected = -1;
      //console.log(e.left + this.puzzle[index].cropp.width / 2 + ' x ' + e.top + this.puzzle[index].cropp.height / 2);
      setTimeout(() => {
        this.checkPosition(
          e.left + this.puzzle[index].cropp.width / 2,
          e.top + this.puzzle[index].cropp.height / 2,
          index
        );
      }, 100);
    },
    giveMeImagePlease(path) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
    },
    setPuzzle(w, h) {
      let tmpX = 0;
      let tmpY = 0;
      let tmpW = w / this.startGameConfig.puzzle.numerOfX;
      let tmpH = h / this.startGameConfig.puzzle.numerOfY;
      for (let i = 0; i < this.startGameConfig.puzzle.numerOfX * this.startGameConfig.puzzle.numerOfY; i++) {
        let tmpL;
        let tmpT;
        let tmpR;
        let tmpB;
        if (tmpX == this.startGameConfig.puzzle.numerOfX) {
          tmpY = tmpY + 1;
          tmpX = 0;
        }
        // 0
        if (tmpX == 0) {
          tmpL = '0';
        } else if (this.puzzle[i - 1].clipPathArray[2] == '1') {
          tmpL = '9';
        } else {
          tmpL = '1';
        }
        // 1
        if (tmpY == 0) {
          tmpT = '0';
        } else if (this.puzzle[i - this.startGameConfig.puzzle.numerOfX].clipPathArray[3] == '1') {
          tmpT = '9';
        } else {
          tmpT = '1';
        }
        // 2
        if (tmpX == this.startGameConfig.puzzle.numerOfX - 1) {
          tmpR = '0';
        } else {
          tmpR = this.getRandom('19');
        }
        //3
        if (tmpY == this.startGameConfig.puzzle.numerOfY - 1) {
          tmpB = '0';
        } else {
          tmpB = this.getRandom('19');
        }
        this.correct.push({ name: i, connect: -1 });
        let xPos = 0;
        let yPos = 0;
        if (this.startGameConfig.staticPos) {
          xPos = this.startGameConfig.staticPos.x[this.randomNumber(2, 0)];
          yPos = this.randomNumber(window.innerHeight * 0.8 - tmpH, window.innerHeight * 0.15);
        } else {
          xPos = this.randomNumber(window.innerWidth * 0.9 - tmpW, 0);
          yPos = this.randomNumber(window.innerHeight * 0.9 - tmpH, 0);
        }
        this.puzzle.push({
          src: this.startGameConfig.puzzle.src,
          cropp: {
            pos: {
              x: -1 * tmpW * tmpX + 0.5 * tmpW,
              y: -1 * tmpH * tmpY + 0.5 * tmpH,
              unit: 'px ',
            },
            width: tmpW + 1 * tmpW,
            widthPlus: 1 * tmpW,
            height: tmpH + 1 * tmpH,
            heightPlus: 1 * tmpH,
          },
          pos: {
            x: xPos,
            y: yPos,
            // x: tmpW * tmpX,
            // y: tmpH * tmpY,
          },
          //L T R B
          clipPathArray: tmpL + tmpT + tmpR + tmpB,
          clipPath: [
            this.clipPathCreate(tmpL, 0),
            this.clipPathCreate(tmpT, 1),
            this.clipPathCreate(tmpR, 2),
            this.clipPathCreate(tmpB, 3),
          ],
          correct: i,
        });
        tmpX = tmpX + 1;
      }
    },
    init() {
      let tmpH;
      let tmpW;
      let img = new Image();
      img.onload = (img) => {
        tmpH = img.path[0].height;
        tmpW = img.path[0].width;
        this.setPuzzle(tmpW, tmpH);
      };
      img.src = this.giveMeImagePlease(this.startGameConfig.puzzle.src);
    },
    shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    randomNumber(x, n) {
      return Math.floor(Math.random() * x) + n;
    },
    getRandom(letters) {
      let tmp = '';
      tmp += letters[Math.floor(Math.random() * letters.length)];
      return tmp;
    },
    getRandomColor() {
      let letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
  },
  destroyed() {},
  computed: {
    backgroundImageUrl() {
      return 'static/' + this.startGameConfig.background;
    },
  },
};
</script>
<style lang="sass" scoped>
// @import '~pretty-checkbox/src/pretty-checkbox.scss';
@import '~@/assets/sass/variable'
@import '~@/assets/sass/iconColor'
$backgroundWidth: 1906px
$backgroundHeight: 1030px
$backgroundOffsetTop: 140px
$backgroundOffsetLeft: 0
.main-img
  position: fixed
  object-fit: cover
.mb-puzzle
  background-size: contain
  background-repeat: no-repeat
  position: relative
  left: $backgroundOffsetLeft
  overflow: hidden
  height: 100%
  width: 100%
  top: 0px
  .puzzle-piece
    position: absolute
  .puzzle-grid
    position: absolute
    top: 0px
    width: 100%
    height: 100%
    left: 0
  .preview
    width: 50%
    margin-left: 25%
    margin-top: 1vh
    text-align: center
    background: #00a8ec
    color: white
    border-radius: 5em
    border: 1px solid #00a8ec
    transition: .5s
    &:hover
      background: white
      color: #00a8ec
.vdr.active:before
  outline: none !important

.modal-fade-leave-active, .modal-fade-enter-active
  transition: all .1s linear
.modal-fade-leave-to, .modal-fade-enter
  transform: scale(1.5,1.5)
  opacity: 0
</style>
